import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Button } from 'shared/components/Buttons';

import { ConfigCookieWrapper } from './styles';

const ConfigCookie = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <ConfigCookieWrapper>
      <div className="main-config-cookie">
        <div className="config-cookie-container">
          <span className="config-cookie-span"> {t('cookies_body')}</span>
          <div className="config-cookie-action">
            <Button
              className="home__btn text-uppercase"
              type="button"
              label={t('cookies_accept_all')}
              color="primary"
              onClick={() => onClick()}
            />
          </div>
        </div>
      </div>
    </ConfigCookieWrapper>
  );
};

ConfigCookie.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ConfigCookie;
